import {Box, Button} from "@mui/material";
import React from "react";
import FieldViewService from "../../services/FieldViewService";
import FieldViewResponse from "../../interfaces/FieldView/FieldViewResponse";
import moment from "moment";
import CreateFieldDialog from "./CreateFieldDialog";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {CustomSnackbarTypes} from "../Common/CustomSnackBar";
import UpdateFieldDialog from "./UpdateFieldDialog";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";

//Common styles
import { WorkspaceContainer } from "../../styles/commonStyles";

const fieldViewService = new FieldViewService();

const CreateFieldList = () => {
    const [fieldListData, setFieldListData] = React.useState<FieldViewResponse[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [openUpdateDialog, setOpenUpdateDialog] = React.useState<boolean>(false);
    const [fieldToUpdate, setFieldToUpdate] = React.useState<FieldViewResponse>();
    const [openCreateFieldDialog, setOpenCreateFieldDialog] = React.useState<boolean>(false);

    const getAllFieldList = () => {
        setLoading(true);
        fieldViewService?.getAllDetailParameters(100, 0).then((res: {total: number, data: FieldViewResponse[]}) => {
            if(res) {
                setLoading(false);
                setFieldListData(res?.data);
            }
        }).catch((err) => {
            setLoading(false);
        })
    }
    const handleUpdateClicked = (field: FieldViewResponse) => {
        setFieldToUpdate(field);
        setOpenUpdateDialog(true);
    }
    const handleCreateFieldClicked = () => {
        setOpenCreateFieldDialog(true);
    }
    const handleCreateFieldSubmitClicked = (inputType: string, values: string[], label: string, isActive: boolean) => {
        if(inputType && values && label) {
            setLoading(true);
            const payload = {
                inputType: inputType,
                values: values?.length >0 ? JSON.stringify(values) : "",
                label: label,
                isActive: isActive
            }
            fieldViewService?.createAdditionalDetailParameters(payload).then((res: FieldViewResponse) => {
                if(res) {
                    setLoading(false);
                    setOpenCreateFieldDialog(false);
                    EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: 'Field Created Successfully',
                        type: CustomSnackbarTypes.SUCCESS
                    });
                    getAllFieldList();
                }
            })
        } else {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: 'Please fill all the fields',
                type: CustomSnackbarTypes.ERROR
            });
        }
    }
    const handleUpdateSubmitClicked = (payload: any) => {
        setLoading(true);
        if(fieldToUpdate?.id) {
            fieldViewService?.updateAdditionalDetailParameters(fieldToUpdate?.id, payload).then((res: FieldViewResponse) => {
                if(res) {
                    setLoading(false);
                    setOpenUpdateDialog(false);
                    EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: 'Field Updated Successfully',
                        type: CustomSnackbarTypes.SUCCESS
                    });
                    getAllFieldList();
                }
            }).catch((err) => {
                setLoading(false);
            })
        }

    }
    React.useEffect(() => {
        getAllFieldList();
    }, [])

    const columns: CommonListColumn<FieldViewResponse>[] = [
        { label: "Id", field: "id" },
        { label: "Input Type", field: "inputType" },
        {
            label: "Values",
            render: (field) => (
                <Box
                    sx={{
                        // constrain the width so long values wrap onto
                        // multiple lines — everything stays fully visible
                        maxWidth: "340px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                    }}
                >
                    {field?.values || "-"}
                </Box>
            ),
        },
        {
            label: "Label",
            render: (field) => (
                <Box
                    sx={{
                        maxWidth: "220px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                    }}
                >
                    {field?.label || "-"}
                </Box>
            ),
        },
        {
            label: "Active",
            render: (field) => (field?.isActive ? "Yes" : "No"),
        },
        {
            label: "Created At",
            nowrap: true,
            render: (field) => moment(field?.createdAt).format('DD MMM YYYY hh:mm A'),
        },
        {
            label: "Updated At",
            nowrap: true,
            render: (field) => moment(field?.updatedAt).format('DD MMM YYYY hh:mm A'),
        },
        {
            label: "",
            stopRowClick: true,
            render: (field) => (
                <Button
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    onClick = {() => {handleUpdateClicked(field)}}
                >
                    Update
                </Button>
            ),
        },
    ];

    return(
        <WorkspaceContainer>
            <CommonListTable
                title="Additional Field Filter"
                headerRight={
                    <Button
                        variant={'contained'}
                        color={'primary'}
                        size={'small'}
                        sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
                        onClick = {handleCreateFieldClicked}
                    >
                        Create Field
                    </Button>
                }
                columns={columns}
                data={fieldListData}
                loading={loading}
            />
            {/*Create Dialog Here */}
            {openCreateFieldDialog && (
                <CreateFieldDialog
                    open={openCreateFieldDialog}
                    onClose={() => setOpenCreateFieldDialog(false)}
                    handleSubmitClicked={handleCreateFieldSubmitClicked}
                />
            )}
            {/*Update Dialog Here */}
            {openUpdateDialog && fieldToUpdate && (
                <UpdateFieldDialog
                    field={fieldToUpdate}
                    open={openUpdateDialog}
                    onClose={() => setOpenUpdateDialog(false)}
                    handleSubmitClicked={handleUpdateSubmitClicked}
                />
            )}
        </WorkspaceContainer>
    )
}

export default CreateFieldList;
